import { PluginObject } from 'vue'
import { IStrings } from './dd-strings.types'
import strings from './dd-strings.strings'

export default {
  install(Vue, options) {
    Vue.prototype.$strings = strings
  },
} as PluginObject<IStrings>
